<template>
  <el-dialog
    title="添加监测内容"
    :visible="visible"
    width="620px"
    :close-on-click-modal="false"
    :close-on-press-escape="!saving"
    :show-close="!saving"
    :before-close="beforeClose"
  >
    <el-alert type="info" :closable="false" title="可粘贴链接或导入 XLSX；平台未返回的数据会明确标记。" />
    <el-input v-model="draft" type="textarea" :rows="7" class="mt" :disabled="saving" placeholder="每行一条内容链接" />
    <el-upload
      :auto-upload="false"
      :limit="1"
      accept=".xlsx"
      :disabled="saving"
      :on-change="fileChanged"
    >
      <el-button size="small" :disabled="saving">选择链接表</el-button>
    </el-upload>
    <div class="mt">
      更新方式：
      <el-radio-group v-model="mode" :disabled="saving">
        <el-radio label="continuous">持续追踪</el-radio>
        <el-radio label="once">仅采集一次</el-radio>
      </el-radio-group>
    </div>
    <span slot="footer">
      <el-button :disabled="saving" @click="close">取消</el-button>
      <el-button type="primary" :loading="saving" @click="submit">{{ saving ? '添加中' : '开始追踪' }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { yuqingApi } from '@/api/yuqing'

export default {
  props: ['visible'],
  data () {
    return { draft: '', file: null, mode: 'continuous', saving: false }
  },
  methods: {
    fileChanged (file) {
      if (!this.saving) this.file = file.raw
    },
    reset () {
      this.draft = ''
      this.file = null
      this.mode = 'continuous'
    },
    close () {
      if (this.saving) return
      this.reset()
      this.$emit('update:visible', false)
    },
    beforeClose (done) {
      if (this.saving) return
      this.reset()
      done()
      this.$emit('update:visible', false)
    },
    async submit () {
      if (this.saving) return
      const urls = this.draft.split(/\n/).map(value => value.trim()).filter(Boolean)
      if (!this.file && !urls.length) {
        this.$message.warning('请粘贴至少一条内容链接或选择链接表')
        return
      }
      this.saving = true
      try {
        let result
        if (this.file) {
          const form = new FormData()
          form.append('file', this.file)
          form.append('tracking_mode', this.mode)
          result = await yuqingApi.upload('content-trackers/import', form)
        } else {
          result = await yuqingApi.post('content-trackers', { urls, tracking_mode: this.mode })
        }
        this.$message.success(`已添加 ${(result.trackers || []).length} 条内容`)
        this.saving = false
        this.close()
        this.$emit('success')
      } catch (error) {
        this.$message.error(error.message || '添加监测内容失败')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
<style scoped>.mt{margin-top:16px}</style>
